import { supportedRecordingType } from "./audio.ts";
import { ChevronRight, Keyboard, Microphone } from "./icons.tsx";
import { Card, Row, RowLink, ScreenHead, ScreenTitle } from "./ui.tsx";

interface Props {
  onBack: () => void;
  onRecord: () => void;
  onType: () => void;
}

/** One decision: record it, or type it. */
export function AddMessageScreen({ onBack, onRecord, onType }: Props) {
  const canRecord = supportedRecordingType() !== null;
  return (
    <>
      <ScreenHead onBack={onBack} />
      <ScreenTitle centred>How would you like to add it?</ScreenTitle>
      <Card class="card-rows card-raised">
        {canRecord ? (
          <RowLink
            label="Record it yourself"
            leading={
              <span class="chooser-icon">
                <Microphone />
              </span>
            }
            title="Record it yourself"
            meta="Use your microphone"
            trailing={<ChevronRight />}
            onClick={onRecord}
          />
        ) : (
          <Row
            class="row-disabled"
            leading={
              <span class="chooser-icon">
                <Microphone />
              </span>
            }
            title="Record it yourself"
            meta="This browser cannot record audio. Try Chrome, Firefox, or Safari."
          />
        )}
        <RowLink
          label="Type what it should say"
          leading={
            <span class="chooser-icon">
              <Keyboard />
            </span>
          }
          title="Type what it should say"
          meta="Choose a voice"
          trailing={<ChevronRight />}
          onClick={onType}
        />
      </Card>
    </>
  );
}
